module.exports = __webpack_public_path__ + "static/media/attach-gif-demo.0818a471.gif";


//////////////////
// WEBPACK FOOTER
// ./client/assets/attach-gif-demo.gif
// module id = 367
// module chunks = 0